// relative imports
import {
  isFeatureEnabled,
  isModuleEnabled,
} from '../../../../data/app-config/configs/configUtilities';
import { useAccountConfig } from '../../../providers/AccountConfigProvider';
import { useAccount } from '../../../providers/AccountProvider';
import SelectAccountDisplay from './SelectAccountDisplay';
import SimpleAccountDisplay from './SimpleAccountDisplay';

const AccountWindow = () => {
  const accountConfigData = useAccountConfig();
  const accountConfig = accountConfigData?.accountConfig || {};
  const accountData = useAccount();
  const { clientPermissions: permissions = {} } = accountData || {};
  const { isAdminViewingClient } = permissions;

  const canSwitchAccounts =
    isModuleEnabled({
      accountConfig,
      moduleName: 'accountSelection',
    }) ||
    (isAdminViewingClient &&
      isFeatureEnabled({
        accountConfig,
        moduleName: 'client',
        featureName: 'adminClientAccountSelection',
      }));

  if (accountConfig?.id) {
    if (canSwitchAccounts) {
      return <SelectAccountDisplay />;
    }

    return <SimpleAccountDisplay />;
  }
  return null;
};

export default AccountWindow;
